<template>
  <v-dialog
    v-model="dialog"
    max-width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        depressed
        v-on="on"
      >
        {{ $t('TrainingClient.Course.ApplyWithClassCode') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ $t('TrainingClient.Course.ApplyWithClassCode') }}</v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field
          v-model="classCode"
          :label="$t('TrainingClient.Course.ClassCode')"
          required
        />
        <div class="grey--text">
          {{ $t('TrainingClient.Course.ClassCodeRemark') }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
        <v-btn
          ref="submitButton"
          color="primary"
          text
          @click="submit"
        >
          {{ $t('TrainingClient.Apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import courseApi from '../../../api/training/course'
export default {
  data: () => ({
    dialog: false,
    classCode: null
  }),
  methods: {
    submit: function () {
      courseApi.getCourseByClassCode(this.classCode, cb => {
        if (cb.status === 200 || cb.status === 201) {
          if (!cb.data.afId) {
            this.$store.dispatch('courses/putCourseIntoCourses', cb.data)
            this.$router.push('/training/applyForm/' + cb.data.pcDetail.id)
            this.dialog = false
          } else {
            let errorMessage = { chinMessage: this.$t('Training.Applied', 'zh'), portMessage: this.$t('Training.Applied', 'pt') }
            this.$store.dispatch('global/setSnackbarMsg', this.$chPtObjData('chinMessage', errorMessage))
            this.dialog = true
          }
        } else {
          let errorMessage = { chinMessage: this.$t('Training.Error.CourseNotFound', 'zh'), portMessage: this.$t('Training.Error.CourseNotFound', 'pt') }
          this.$store.dispatch('global/setSnackbarMsg', this.$chPtObjData('chinMessage', errorMessage))
          this.dialog = true
        }
      })
    }
  }
}
</script>
